import { render, staticRenderFns } from "./CustomerView.vue?vue&type=template&id=1791e1c8&scoped=true"
import script from "./CustomerView.vue?vue&type=script&lang=js"
export * from "./CustomerView.vue?vue&type=script&lang=js"
import style0 from "./CustomerView.vue?vue&type=style&index=0&id=1791e1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1791e1c8",
  null
  
)

export default component.exports